import { Skeleton } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { CpSectionWrapper } from 'components/organisms/customer-portal/widgets/common';
import { CpLoadingDesc, CpLoadingProps, CpLoadingTitle } from '../common';

const StoriesWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: var(--cp-spacing-06);
  margin-bottom: var(--cp-spacing-06);
  @media (max-width: 768px) {
    overflow-x: auto;
    gap: var(--cp-spacing-04);
  }
`;

const ProjectUpdateStorySkeleton = styled(Skeleton.Button)`
  .ant-skeleton,
  &.ant-skeleton {
    height: 490px !important;
    width: 355px !important;

    @media (max-width: 480px) {
      max-width: 86svw !important;
      min-width: 86svw !important;
      width: 86svw !important;
    }
  }

  .ant-skeleton-button {
    height: 100% !important;
    width: 100% !important;
  }
`;

export const CpProjectUpdatesLoading: React.FC<CpLoadingProps> = ({
  styles,
}) => {
  return (
    <CpSectionWrapper
      background={styles?.background as string}
      paddingY={styles?.paddingY as number | undefined}
      className="!cp-max-w-none"
    >
      <CpLoadingTitle active />
      <CpLoadingDesc active />

      <StoriesWrapper>
        <ProjectUpdateStorySkeleton active shape="square" />
        <ProjectUpdateStorySkeleton active shape="square" />
        <ProjectUpdateStorySkeleton active shape="square" />
      </StoriesWrapper>
    </CpSectionWrapper>
  );
};
